import React from "react";
import {
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Modal,
  Button,
  Form
} from "react-bootstrap";
import Card from "../../../components/Card";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { ProductString } from "../../../constants/Product-Strings";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { useState } from "react";
import { useEffect } from "react";
import ServicesRequest from "../../../service/ServiceRequest";
import { successToast, warningToast } from "../../../constants/Toasts-Components";


import SearchComponent from '../../../components/partials/backend/Search/SearchComponent'
import SortToggle from '../../../components/partials/backend/SortToggle/SortToggle'
import FilterComponent from '../../../components/partials/backend/Filter/FilterComponent'
import PaginationComponent from '../../../components/partials/backend/Pagination/PaginationComponent'
import { AgentString } from "../../../constants/Agent-String";

const Agent = (props) => {

  let serviceRequestObj = new ServicesRequest("user");


  const [products, setProducts] = useState([]);
  const [paginationObject, setPaginationObject] = useState(null);

  const { config } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");
  const [filter, setFilter] = useState("");
  const [nPages, setPage] = useState(0);
  const [page, setCurrentPage] = useState(1);
  const [numberOfItem, setNumberOfItem] = useState(0);
  
  // Reassign modal states
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [users, setUsers] = useState([]);
  const [agencies, setAgencies] = useState([]);
  // Only agency assignment is allowed now
  const [reassignSelectedAgencyId, setReassignSelectedAgencyId] = useState('');

  async function fetchProductList(url = null) {
    setLoading(true);
    const response = await serviceRequestObj.getProductList(filter, sort, search, page, url);
    console.log(response)
    if (!response.response) {

      setProducts(response.data.filter(item => item.email !== config.email));
      setPaginationObject(response.pagination);
      setPage(response.pagination.n_pages)
      setCurrentPage(response.pagination.current_page)
      setNumberOfItem(response.pagination.n_items)
      
    }
    props.location.state = {}
    setLoading(false);
  }

  async function loadUsers(){
    const userService = new ServicesRequest("user")
    const response = await userService.getProductListComplete()
    if (!response.response) {
      setUsers(response.data || [])
    }
  }

  async function loadAgencies(){
    const agencyService = new ServicesRequest("agency")
    const response = await agencyService.getProductListComplete()
    if (!response.response) {
      setAgencies(response.data || [])
    }
  }

  async function handleReassign(agentEmail, assignedUserId, assignedAgencyId) {
    try {
      console.log("Reassigning agent...", {
        agentEmail,
        assignedUserId,
        assignedAgencyId
      })
      
      const userService = new ServicesRequest("user")
      const result = await userService.assignUser(
        agentEmail,
        assignedUserId || null,
        assignedAgencyId || null
      )
      
      console.log("Assignment result:", result)
      
      if (result && (result.id || result.success || !result.response)) {
        successToast('Agente riassegnato con successo')
        setShowReassignModal(false)
        setSelectedAgent(null)
        // Clear only agency selection (user assignment no longer supported)
        setReassignSelectedAgencyId('')
        // Reload the agent list
        await fetchProductList()
      } else if (result && result.error) {
        warningToast('Errore: ' + result.error)
      } else {
        warningToast('Errore: Impossibile riassegnare l\'agente')
      }
    } catch (error) {
      console.error('Error in handleReassign:', error)
      warningToast('Errore durante la riassegnazione')
    }
  }

  useEffect(() => {
    fetchProductList();
    // Load users and agencies only if user is admin or agency_boss
    if (config.is_admin || config.is_agency_boss) {
      loadUsers();
      loadAgencies();
    }
    return () => {
      setProducts([]);
    };
  }, [search, sort, filter]);

  // Check if user has permission to view this page
  if (config.is_agent || config.is_internal_backoffice_operator || config.is_institute_backoffice_operator || config.is_business_manager) {
      return (
          <Container fluid>
              <Row>
                  <Col lg="12">
                      <Card>
                          <Card.Body>
                              <div className="text-center">
                                  <h4 className="text-danger">Accesso Negato</h4>
                                  <p>Non hai i permessi per visualizzare questa pagina.</p>
                              </div>
                          </Card.Body>
                      </Card>
                  </Col>
              </Row>
          </Container>
      );
  }
  
  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="12">
            <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="font-weight-bold">{AgentString.title}</h4>
              </div>
              <div className="create-workform">
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                  <div className="modal-product-search d-flex">
                    <div className="mr-3 position-relative">
                      <SearchComponent search={search} setSearch={setSearch} setCurrentPage={setCurrentPage}/>
                    </div>

                    {config.can_create && (config.is_admin || config.is_agency_boss || config.is_agency_admin || config.is_internal_backoffice_manager || config.is_institute_backoffice_manager) && (
                      <Link
                        to="/agent-add"
                        className="btn btn-primary position-relative d-flex align-items-center justify-content-between"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="mr-2"
                          width="20"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                          />
                        </svg>
                        {AgentString.addAgent}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <Row>
              <Col lg="12">
                <Card className="card-block card-stretch">
                  <Card.Body className="p-0">
                    <div className="table-responsive">
                      <table className="table data-table mb-0">
                        <thead className="table-color-heading">
                          <tr className="text-light">
                            <th scope="col" style={{ width: "20%" }}>
                              <label className="text-muted m-0">
                                {AgentString.name}
                              </label>
                              <SortToggle
                                field="name"
                                setSort={setSort}
                                fetchList={fetchProductList}
                                setCurrentPage={setCurrentPage}
                                id={1}
                              ></SortToggle>
                            </th>

                            <th scope="col" style={{ width: "15%" }}>
                              <label className="text-muted m-0">
                                {AgentString.email}
                              </label>
                              <SortToggle
                                field="email"
                                setSort={setSort}
                                fetchList={fetchProductList}
                                setCurrentPage={setCurrentPage}
                                sort={sort}
                                id={2}
                              ></SortToggle>
                            </th>

                            <th
                              scope="col"
                              className="text-left"
                              style={{ width: "15%" }}
                            >
                              <label className="text-muted m-0">
                                {AgentString.agency}
                              </label>
                              <SortToggle
                                field="agency__name"
                                setSort={setSort}
                                fetchList={fetchProductList}
                                setCurrentPage={setCurrentPage}
                                sort={sort}
                                id={3}
                              ></SortToggle>
                            </th>

                            <th
                              scope="col"
                              className="text-left"
                              style={{ width: "10%" }}
                            >
                              <label className="text-muted m-0">
                                Ruolo
                              </label>
                            </th>

                            <th
                              scope="col"
                              className="text-left"
                              style={{ width: "10%" }}
                            >
                              <label className="text-muted m-0">
                                Last Activity
                              </label>
                            </th>

                            <th
                              scope="col"
                              className="text-left"
                              style={{ width: "10%" }}
                            >
                              <label className="text-muted m-0">
                                Last Login
                              </label>
                            </th>

                            <th
                              scope="col"
                              className="text-left"
                              style={{ width: "5%" }}
                            >
                              <label className="text-muted m-0">
                                Online
                              </label>
                            </th>

                            {(config.is_admin || config.is_agency_boss || config.is_agency_admin || config.is_internal_backoffice_manager || config.is_institute_backoffice_manager) && (
                              <th
                                scope="col"
                                className="text-left"
                                style={{ width: "5%" }}
                              >
                                <label className="text-muted m-0">
                                  Sospendi
                                </label>
                              </th>
                            )}

                            {config.is_admin && (
                              <th
                                scope="col"
                                className="text-left"
                                style={{ width: "5%" }}
                              >
                                <label className="text-muted m-0">
                                  Creazione
                                </label>
                              </th>
                            )}

                            <th
                                scope="col"
                                className="text-left"
                                style={{ width: "5%" }}
                              >
                                {!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager ? (
                                  <label className="text-muted m-0">Stato</label>
                                ) : (
                                  <FilterComponent filter={filter} setFilter={setFilter} setCurrentPage={setCurrentPage} />
                                )}
                              </th>

                            <th
                                scope="col"
                                className="text-left"
                                style={{ width: "5%" }}
                              >
                                <div className="d-flex align-items-center justify-content-between">
                                  <label className="text-muted m-0">Opp Attive</label>
                                </div>
                              </th>

                            <th
                              scope="col text-center"
                              style={{ width: "10%" }}
                            >
                              <div className="d-flex align-items-center justify-content-between">
                                <label className="text-muted m-0">Azioni</label>
                                
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="smooth-transition">
                          {loading ? (
                            <tr style={{ height: "100px", paddingTop: "10px" }}>
                              <td>
                                <p className="loader"></p>
                              </td>
                            </tr>
                          ) : (
                            <>
                              {products.map((item, index) => (

                                <tr key={index} className="white-space-no-wrap">

                                  <td className="" style={{ width: "20%" }}>
                                    <div className="active-project-1 d-flex align-items-center mt-0 ">
                                      <div className="data-content">
                                        <div>
                                          <span className="font-weight-bold">
                                            {
                                            `${item.name} ${item.surname}`.length > 20
                                              ? 
                                              (`${item.name} ${item.surname}`.substring(0, 20)+"...") :`${item.name} ${item.surname}`
                                            }
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </td>

                                  <td style={{ width: "15%" }}> {item.email.length > 20
                                              ? 
                                              (item.email.substring(0, 20)+"...") :item.email}</td>

                                  <td style={{ width: "15%" }} className="text-left">
                                    {(item.is_agency_boss || item.is_agent) ? (
                                      // Show single agency for agency boss
                                      item.agency !== null ? item.agency.name : ""
                                    ) : (
                                      // Show managed agencies for other roles
                                      item.managed_agencies && item.managed_agencies.length > 0 ? (
                                        <div>
                                          {item.managed_agencies.map((agency, idx) => (
                                            <span 
                                              key={idx} 
                                              className="badge bg-info mr-1 mb-1"
                                              style={{ fontSize: '11px', padding: '4px 8px' }}
                                            >
                                              {agency.name}
                                            </span>
                                          ))}
                                        </div>
                                      ) : (
                                        <span className="text-muted">No agencies</span>
                                      )
                                    )}
                                  </td>

                                  <td style={{ width: "10%" }} className="text-left">
                                    {item.is_agent ? (
                                      <span className="badge bg-dark" style={{ fontSize: '11px' }}>Agente di Agenzia</span>
                                    ) : item.is_agency_boss ? (
                                      <span className="badge bg-success" style={{ fontSize: '11px' }}>Responsabile di Agenzia</span>
                                    ) : item.is_agency_admin ? (
                                      <span className="badge bg-primary" style={{ fontSize: '11px' }}>Amministratore di Agenzia</span>
                                    ) : item.is_business_manager ? (
                                      <span className="badge bg-warning" style={{ fontSize: '11px' }}>Responsabile Commerciale</span>
                                    ) : item.is_internal_backoffice_manager ? (
                                      <span className="badge bg-info" style={{ fontSize: '11px' }}>Responsabile BO Interno</span>
                                    ) : item.is_internal_backoffice_operator ? (
                                      <span className="badge bg-info" style={{ fontSize: '11px' }}>Operatore BO Interno</span>
                                    ) : item.is_institute_backoffice_manager ? (
                                      <span className="badge bg-secondary" style={{ fontSize: '11px' }}>Responsabile BO Istituto</span>
                                    ) : item.is_institute_backoffice_operator ? (
                                      <span className="badge bg-secondary" style={{ fontSize: '11px' }}>Operatore BO Istituto</span>
                                    ) : (
                                      <span className="text-muted">-</span>
                                    )}
                                  </td>

                                  <td style={{ width: "10%" }} className="text-left">
                                    {item.last_activity}
                                  </td>

                                  <td style={{ width: "10%" }} className="text-left">
                                    {item.last_login}
                                  </td>

                                  <td style={{ width: "5%" }} className="text-left">
                                    {item.is_online ? (
                                      <span className="badge bg-success">Online</span>
                                    ) : (
                                      <span className="badge bg-secondary">Offline</span>
                                    )}
                                  </td>

                                  {(config.is_admin || config.is_agency_boss || config.is_agency_admin || config.is_internal_backoffice_manager || config.is_institute_backoffice_manager) && (
                                    <td style={{ width: "5%" }} className="text-left">
                                      <OverlayTrigger
                                              placement="top"
                                              overlay={<Tooltip>Sospendi/Attiva Agente</Tooltip>}
                                            >
                                              <BootstrapSwitchButton
                                                checked={
                                                  item.status === 'attivo' ? true:false
                                                }
                                                onstyle="success"
                                                size="sm"
                                                onChange={async (e) => {
                                                  const resp =
                                                    await serviceRequestObj.toggleSuspendProduct(
                                                      item.email
                                                    );

                                                  if (resp !== null) {
                                                    
                                                    if(item.status === "attivo"){
                                                        products[index].status = "sospeso";
                                                        console.log(products[index].status)
                                                        setProducts([...products])

                                                    }else if(item.status === "sospeso")
                                                    // item.status = "attivo";
                                                    products[index].status = "attivo";
                                                    console.log(products[index].status)
                                                    setProducts([...products])
                                                    
                                                  }
                                                }}
                                                disabled={item.status === "disattivo" ? true : false}
                                              ></BootstrapSwitchButton>
                                            </OverlayTrigger>
                                      </td>
                                  )}

                                  {config.is_admin && (
                                    <td style={{ width: "5%" }} className="text-left">
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={<Tooltip>Abilita/Disabilita Creazione</Tooltip>}
                                            >
                                              <BootstrapSwitchButton
                                                checked={item.can_create || false}
                                                onstyle="primary"
                                                offstyle="secondary"
                                                size="sm"
                                                onChange={async (e) => {
                                                  const resp =
                                                    await serviceRequestObj.toggleCanCreateProduct(
                                                      item.email
                                                    );

                                                  if (resp !== null) {
                                                    products[index].can_create = !products[index].can_create;
                                                    setProducts([...products])
                                                  }
                                                }}
                                                disabled={item.status === "disattivo" ? true : false}
                                              ></BootstrapSwitchButton>
                                            </OverlayTrigger>
                                      </td>
                                  )}

                                  <td style={{ width: "5%" }} className="text-left">
                                     <div className="d-flex align-items-center">
                                        
                                        <h6
                                          style={{'transition':'.2s ease-in-out'}}
                                          className={`${
                                            item.status === 'attivo'
                                              ? "bg-success"
                                              : item.status === 'sospeso'
                                              ? "bg-warning"
                                              : "bg-danger"
                                          } rounded rounded-pill px-2 py-1 mx-2 mb-0`}
                                        >
                                          {item.status}
                                        </h6>
                                      </div>
                                  </td>

                                  <td style={{ width: "5%" }} className="text-left">
                                     <span className="badge bg-secondary mr-2" style={{ fontSize: '12px', padding: '6px 10px' }}>
                                        Opp: {item.active_opportunities_count}
                                      </span>
                                  </td>

                                  <td style={{ width: "10%" }} >
                                    <div className="d-flex justify-content-between align-items-center">

                                      <div className="d-flex align-items-center">
                                        

                                        {item.status !== "disattivo" && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {config.is_admin ? "Modifica Agente" : "Visualizza Agente"}
                                          </Tooltip>
                                        }
                                      >
                                        <Link to={{ pathname: `/agent-view/${item.email}`, state: {"filter" : filter, 
                                                                                                  "sort" : sort, 
                                                                                                  "search" : search, 
                                                                                                  "page" : page} }}>
                                          {config.is_admin ? (
                                            <>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="text-secondary mx-4"
                                                width="20"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                              >
                                                <path
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeWidth="2"
                                                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                                />
                                              </svg>
                                            </>
                                          ) : (
                                            <>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="text-secondary mx-4"
                                                width="20"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                              >
                                                <path d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z" />
                                              </svg>
                                            </>
                                          )}
                                        </Link>
                                      </OverlayTrigger>
                                      )}
                                      {item.status === "disattivo" && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {config.is_admin ? "Impossibile Modificare" : "Impossibile Visualizzare"}
                                          </Tooltip>
                                        }
                                      >
                                        <div>
                                          {config.is_admin ? (
                                            <>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="text-secondary mx-4"
                                                width="20"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                              >
                                                <path
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeWidth="2"
                                                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                                />
                                              </svg>
                                            </>
                                          ) : (
                                            <>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="text-secondary mx-4"
                                                width="20"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                              >
                                                <path d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z" />
                                              </svg>
                                            </>
                                          )}
                                        </div>
                                      </OverlayTrigger>
                                      )}

                                      {config.is_admin && item.status !== "disattivo" && (
                                        <>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip>Elimina Agente</Tooltip>}
                                          >
                                            <h6
                                              className="badge bg-danger"
                                              onClick={async () => {
                                                const resp =
                                                  await serviceRequestObj.deleteProduct(item.email);
                                                if (resp !== null) {
                                                  await fetchProductList();
                                                }
                                              }}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                              >
                                                <path
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeWidth="2"
                                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                />
                                              </svg>
                                            </h6>
                                          </OverlayTrigger>
                                        </>
                                      )}

                                      {config.is_admin && item.status === "disattivo" && (
                                        <>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip>Impossibile Eliminare</Tooltip>}
                                          >
                                            <h6
                                              className="badge bg-secondary"
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                              >
                                                <path
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeWidth="2"
                                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                />
                                              </svg>
                                            </h6>
                                          </OverlayTrigger>
                                        </>
                                      )}

                                      {(config.is_admin || config.is_agency_boss) && item.status !== "disattivo" && (
                                        <>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip>Riassegna Agente</Tooltip>}
                                          >
                                            <h6
                                              className="badge bg-info mx-2"
                                              style={{ cursor: 'pointer' }}
                                              onClick={() => {
                                                setSelectedAgent(item)
                                                setShowReassignModal(true)
                                                setReassignSelectedAgencyId('')
                                              }}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                              >
                                                <path
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeWidth="2"
                                                  d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                                                />
                                              </svg>
                                            </h6>
                                          </OverlayTrigger>
                                        </>
                                      )}

                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {
                      paginationObject !== null?
                      <PaginationComponent fetchList={fetchProductList} paginationObject={paginationObject} nPages={nPages} page={page} numberOfItem={numberOfItem} />
                      :<></>
                    }
                    
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/* Reassignment Modal */}
      {(config.is_admin || config.is_agency_boss) && (
        <Modal show={showReassignModal} onHide={() => setShowReassignModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Riassegna Agente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedAgent && (
              <>
                <p>Riassegna l'agente <strong>{selectedAgent.name} {selectedAgent.surname}</strong>:</p>
                
                {/* Agency Assignment - only option now */}
                <div className="mb-3">
                  <Form.Label>Assegna a Agenzia:</Form.Label>
                  <Form.Control
                    as="select"
                    id="reassign-agency"
                    value={reassignSelectedAgencyId || ''}
                    onChange={(e) => setReassignSelectedAgencyId(e.target.value)}
                  >
                    <option value="">Seleziona agenzia...</option>
                    {agencies.map(agency => (
                      <option key={agency.id} value={agency.id}>
                        {agency.name}
                      </option>
                    ))}
                  </Form.Control>
                  {reassignSelectedAgencyId && (
                    <div className="mt-2">
                      <Button 
                        variant="primary" 
                        size="sm"
                        onClick={() => handleReassign(selectedAgent.email, null, reassignSelectedAgencyId)}
                      >
                        Assegna a {agencies.find(a => a.id == reassignSelectedAgencyId)?.name}
                      </Button>
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <Button 
                    variant="outline-danger" 
                    size="sm"
                    onClick={() => handleReassign(selectedAgent.email, null, null)}
                  >
                    Rimuovi assegnazione
                  </Button>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              setShowReassignModal(false)
              setSelectedAgent(null)
              setReassignSelectedAgencyId('')
            }}>
              Annulla
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default Agent;
